import React, { useState } from "react";
import { getDateFormat, getHeader } from "../../utils/util";
import { API_ENDPOINT } from "../../constants/constants";
import axios from "axios";
import { toast } from 'react-toastify';

const PlanHistory = ({ planHistory }) => {
  const [loading, setLoading] = useState(false);

  const resendInvoice = (razorId) => {
    setLoading(true);
    axios.post(API_ENDPOINT + "admin/resend-invoice", { razorpayPaymentId: razorId }, getHeader()).then((res) => {
      setLoading(false);
      let d = res.data;
      if (d.success) toast(d.message);
    }).catch(() => { setLoading(false); toast("Request failed") });
  };

  return (
    <div style={{ margin: "auto" }}>
      <table className="table">
        <thead>
          <tr>
            <th>#</th>
            <th>Subscribed On</th>
            <th>Plan</th>
            <th>Candidate Count</th>
            <th>Cost</th>
            <th>Invoice</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {planHistory.map((od, i) => (
            <tr key={od.razorpay_payment_id || i}>
              <td className="text-muted">{i + 1}</td>
              <td className="text-muted">{getDateFormat(new Date(od.createdOn))}</td>
              <td style={{ fontWeight: 600 }}>{od.plan_name}</td>
              <td>{od.slots && od.slots[0] ? od.slots[0].count + od.slots[0].used : "—"}</td>
              <td style={{ fontFamily: 'var(--font-heading)', fontWeight: 800 }}>{od.amount}</td>
              <td>
                <a href={API_ENDPOINT + 'invoices/invoice_' + od.razorpay_payment_id + '.pdf'} target="_blank" rel="noreferrer" style={{ fontSize: 13 }}>Invoice link</a>
              </td>
              <td>
                <button className="btn btn-ghost" style={{ fontSize: 13 }} disabled={loading} onClick={() => resendInvoice(od.razorpay_payment_id)}>
                  Resend invoice
                </button>
              </td>
            </tr>
          ))}
          {planHistory.length === 0 && (
            <tr><td colSpan={7} className="text-muted" style={{ textAlign: "center", padding: 24 }}>No transactions yet</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PlanHistory;
